"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tags = exports.reflect = exports.protobuf = exports.notations = exports.misc = exports.json = exports.llm = exports.http = exports.functional = void 0;
exports.assert = assert;
exports.assertGuard = assertGuard;
exports.is = is;
exports.validate = validate;
exports.assertEquals = assertEquals;
exports.assertGuardEquals = assertGuardEquals;
exports.equals = equals;
exports.validateEquals = validateEquals;
exports.random = random;
exports.createAssert = createAssert;
exports.createAssertGuard = createAssertGuard;
exports.createIs = createIs;
exports.createValidate = createValidate;
exports.createAssertEquals = createAssertEquals;
exports.createAssertGuardEquals = createAssertGuardEquals;
exports.createEquals = createEquals;
exports.createValidateEquals = createValidateEquals;
exports.createRandom = createRandom;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
exports.functional = __importStar(require("./functional"));
exports.http = __importStar(require("./http"));
exports.llm = __importStar(require("./llm"));
exports.json = __importStar(require("./json"));
exports.misc = __importStar(require("./misc"));
exports.notations = __importStar(require("./notations"));
exports.protobuf = __importStar(require("./protobuf"));
exports.reflect = __importStar(require("./reflect"));
exports.tags = __importStar(require("./tags"));
__exportStar(require("./schemas/metadata/IJsDocTagInfo"), exports);
__exportStar(require("./schemas/json/IJsonApplication"), exports);
__exportStar(require("./schemas/json/IJsonSchemaCollection"), exports);
__exportStar(require("./schemas/json/IJsonSchemaUnit"), exports);
__exportStar(require("./AssertionGuard"), exports);
__exportStar(require("./IRandomGenerator"), exports);
__exportStar(require("./IValidation"), exports);
__exportStar(require("./TypeGuardError"), exports);
__exportStar(require("./Primitive"), exports);
__exportStar(require("./Resolved"), exports);
__exportStar(require("./CamelCase"), exports);
__exportStar(require("./PascalCase"), exports);
__exportStar(require("./SnakeCase"), exports);
__exportStar(require("./IReadableURLSearchParams"), exports);
/** @internal */
function assert() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("assert");
}
/** @internal */
function assertGuard() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("assertGuard");
}
/** @internal */
function is() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("is");
}
/** @internal */
function validate() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("validate");
}
/** @internal */
function assertEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("assertEquals");
}
/** @internal */
function assertGuardEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("assertGuardEquals");
}
/** @internal */
function equals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("equals");
}
/** @internal */
function validateEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("validateEquals");
}
/** @internal */
function random() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("random");
}
/** @internal */
function createAssert() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createAssert");
}
/** @internal */
function createAssertGuard() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createAssertGuard");
}
/** @internal */
function createIs() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createIs");
}
/** @internal */
function createValidate() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createValidate");
}
/** @internal */
function createAssertEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createAssertEquals");
}
/** @internal */
function createAssertGuardEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createAssertGuardEquals");
}
/** @internal */
function createEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createEquals");
}
/** @internal */
function createValidateEquals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createValidateEquals");
}
/** @internal */
function createRandom() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("createRandom");
}
//# sourceMappingURL=module.js.map